<template>
  <div class="animated fadeIn">
    <h2>Nadawanie etykiet</h2>
    <b-card>
      <div slot="header">Konfiguracja</div>
      <small style="font-size: 13px; margin-bottom: 10px;" class="form-text text-muted">Etykieta zostanie przypisana gdy warunki zostaną spełnione dla istniejących i przyszłych wierszy w zestawieniu</small>
      <b-form>
        <b-row v-for="(row, index) in formRows" :key="index">
          <b-col sm="4">
            <multiselect placeholder="Wybierz pola" :options="fieldsOptions" :multiple="true" v-model="row.selectedFields"></multiselect>
          </b-col>
          <b-col sm="3">
            <multiselect placeholder="Warunki" :options="conditionsOptions" v-model="row.selectedConditions"></multiselect>
          </b-col>
          <b-col sm="2">
            <b-input type="text" placeholder="Wartość" v-model="row.value"></b-input>
          </b-col>

          <b-col v-if="formRows.length > 1 && index != formRows.length - 1" sm="1">
            <b-form-select :options="['oraz', 'lub']" v-model="row.operator"></b-form-select>
          </b-col>
          <b-col v-if="index > 0" sm="1">
            <i @click="removeRow(index)" class="fa fa-remove"></i>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="2">
            <b-form-group label="Nigdy nie zawiera faktury:" label-for="checkboxes" :label-cols="2">
              <b-form-checkbox :value="true" v-model="label.containInvoice"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-button @click="addRow" type="button" variant="primary">
          <i class="fa fa-plus"></i> Dodaj wiersz</b-button>
      </b-form>
      <hr>
      <b-row>
        <b-col sm="2">
          <b-input v-model="label.name" type="text" placeholder="Nazwa etykiety"></b-input>
        </b-col>
        <b-col sm="2">
          <b-input v-model="label.color" type="text" placeholder="Kolor etykiety"></b-input>
        </b-col>
        <b-col sm="2">
          <multiselect id="years" placeholder="Zakres etykiety" :options="['Koszt', 'Projekt']" v-model="label.scope"></multiselect>
        </b-col>
        <b-col>
          <b-button @click="addLabels" type="submit" variant="primary">
            <i class="fa fa-dot-circle-o"></i> Dodaj etykietę</b-button>
        </b-col>
      </b-row>
    </b-card>

    <Loading :loading="loading.processing" :text="loading.text"></Loading>
  </div>
</template>

<script>
import Vue from "vue";
import * as axios from "axios";

import Multiselect from "vue-multiselect";
import Loading from "@/components/loading.vue";

import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { Switch as cSwitch } from '@coreui/vue'

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(VueNotifications, options);

export default {
  data() {
    return {
      loading: {
        processing: false,
        text: ""
      },
      label: {
        name: "",
        color: "",
        scope: 'Koszt',
        containInvoice: false,
        condition: ""
      },
      formRows: [
        {
          selectedFields: null,
          selectedConditions: null,
          value: "",
          operator: "lub"
        }
      ],
      fieldsOptions: [
        "Id",
        "Nadawca/Odbiorca",
        "Tytuł",
        "Numer konta",
        "Kwota",
        "Saldo",
        "Data operacji",
        "Data księgowania",
        "Opis"
      ],
      conditionsOptions: [
        "Równe",
        "Zawiera",
        "RegEx",
        "Nie Równe",
        "Nie zawiera",
        "Mniejsze od",
        "Mniejsze bądź równe",
        "Większe od",
        "Większe bądź równe"
      ],
      conditionsMap: {
        Równe: "equals",
        Zawiera: "contains",
        RegEx: "matches-RegEx",
        "Nie Równe": "does-not-equal",
        "Nie zawiera": "does-not-contain",
        "Mniejsze od": "less-then",
        "Mniejsze bądź równe": "less-then-or-equal",
        "Większe od": "greater-then",
        "Większe bądź równe": "greater-then-or-equal"
      },
      fieldsMap: {
        Id: "id",
        "Nadawca/Odbiorca": "sender/recipient",
        Tytuł: "title",
        "Numer konta": "account_number",
        Kwota: "amount",
        Saldo: "saldo",
        "Data operacji": "operation_date",
        "Data księgowania": "accounting_date",
        Opis: "description"
      },
      operatorMap: {
        oraz: "and",
        lub: "or"
      }
    };
  },
  methods: {
    addRow() {
      this.formRows.push({
        selectedFields: null,
        selectedConditions: null,
        value: "",
        operator: "lub"
      });
    },
    removeRow(index) {
      this.formRows.splice(index, 1);
    },
    addLabels() {
      const self = this;
      let condition = "";

      this.formRows.map((row, index) => {
        row.selectedFields.forEach((field, index) => {
          let mappedField = self.fieldsMap[field];
          let mappedCondition = self.conditionsMap[row.selectedConditions];

          condition += `${mappedField} ${mappedCondition} ${row.value}`;

          if (index != row.selectedFields.length - 1) {
            condition += " or ";
          }
        });

        if (index != this.formRows.length - 1) {
          condition += ` ${self.operatorMap[row.operator]} `;
        }
      });

      self.label.condition = condition;
      this.loading.processing = true;
      this.loading.text = "Dodawanie etykiety...";
  
      axios
        .post(process.env.VUE_APP_API_URL + "/labels", {
          labelData: self.label
        })
        .then(res => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showSuccessMsg();
        })
        .catch(err => {
          this.loading.processing = false;
          this.loading.text = "";
          this.showError();
        })
    }
  },
  components: {
    Multiselect,
    cSwitch,
    Loading
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: "Sukces",
      message: "Pomyślnie dodano etykietę."
    },
    showError: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Nie udało się dodać etykiety."
    }
  }
};
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
